import React, { useEffect } from 'react';
import JsBarcode from 'jsbarcode';

// ---- Notification ----
export function useNotif() {
  const [notifs, setNotifs] = React.useState([]);
  const show = (msg) => {
    const id = Date.now();
    setNotifs(n => [...n, { id, msg }]);
    setTimeout(() => setNotifs(n => n.filter(x => x.id !== id)), 3500);
  };
  return { notifs, show };
}

export function NotifContainer({ notifs }) {
  return (
    <div className="notif-container">
      {notifs.map(n => (
        <div key={n.id} className="notif">✓ {n.msg}</div>
      ))}
    </div>
  );
}

// ---- Modal ----
export function Modal({ open, onClose, title, children }) {
  useEffect(() => {
    const handler = (e) => { if (e.key === 'Escape') onClose(); };
    if (open) document.addEventListener('keydown', handler);
    return () => document.removeEventListener('keydown', handler);
  }, [open, onClose]);

  if (!open) return null;
  return (
    <div className="modal-overlay" onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}>
      <div className="modal">
        <div className="modal-header">
          <div className="modal-title">{title}</div>
          <button className="modal-close" onClick={onClose}>✕</button>
        </div>
        {children}
      </div>
    </div>
  );
}

// ---- StepBanner ----
// Muestra el contexto del paso actual en el flujo de proceso
export function StepBanner({ step, total = 5, title, desc, prev, next }) {
  return (
    <div style={{
      background: 'var(--primary-light)',
      borderBottom: '1px solid var(--primary-mid)',
      padding: '10px 28px',
      display: 'flex',
      alignItems: 'center',
      gap: 16,
      flexWrap: 'wrap',
    }}>
      {/* Paso */}
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexShrink: 0 }}>
        <div style={{
          width: 28, height: 28, borderRadius: 8,
          background: 'var(--primary)', color: '#fff',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          fontSize: 13, fontWeight: 800, fontFamily: 'var(--font-display)',
        }}>{step}</div>
        <div style={{ fontSize: 11, fontWeight: 700, color: 'var(--primary)', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
          Paso {step} de {total}
        </div>
      </div>

      <div style={{ width: 1, height: 24, background: 'var(--primary-mid)', flexShrink: 0 }} />

      {/* Descripción */}
      <div style={{ fontSize: 12.5, color: 'var(--primary)', flex: 1 }}>
        <strong>{title}:</strong> {desc}
      </div>

      {/* Flujo prev → next */}
      {(prev || next) && (
        <div style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 11.5, flexShrink: 0 }}>
          {prev && <span style={{ color: 'var(--text3)', fontWeight: 600 }}>{prev}</span>}
          {prev && <span style={{ color: 'var(--primary-mid)' }}>→</span>}
          <span style={{ background: 'var(--primary)', color: '#fff', borderRadius: 20, padding: '2px 9px', fontWeight: 700, fontSize: 11 }}>{title}</span>
          {next && <span style={{ color: 'var(--primary-mid)' }}>→</span>}
          {next && <span style={{ color: 'var(--text3)', fontWeight: 600 }}>{next}</span>}
        </div>
      )}
    </div>
  );
}

// ---- LabelPreview ----
export function LabelPreview({ rec }) {
  const ref = React.useRef(null);
  useEffect(() => {
    if (!rec || !ref.current) return;
    try {
      JsBarcode(ref.current, rec.lote, {
        format: 'CODE128', width: 1.8, height: 45, displayValue: true,
        fontSize: 11, margin: 4, background: '#fff', lineColor: '#111'
      });
    } catch (e) {}
  }, [rec]);

  if (!rec) return null;
  return (
    <div className="label-preview">
      <div className="lp-header">
        <div className="lp-logo-box">🏔 Caja Los Andes</div>
        <div style={{ marginLeft: 'auto', fontSize: 10, color: 'rgba(255,255,255,0.8)' }}>TraceOps</div>
      </div>
      <div className="lp-product">{rec.producto}</div>
      <div className="lp-lot">Lote: {rec.lote}</div>
      <svg ref={ref} style={{ width: '100%', maxHeight: 55 }} />
      <div className="lp-row">
        <span>Cantidad: {rec.qty} {rec.unidad}</span>
        <span>Ingreso: {(rec.fecha || '').split(' ')[0]}</span>
      </div>
      <div className="lp-row">
        <span>Prov: {rec.proveedor || '—'}</span>
        <span style={{ color: '#dc2626' }}>Vence: {rec.vence || '—'}</span>
      </div>
    </div>
  );
}
